import React from 'react';

import EyeIcon from 'components/svg/icons/eye.svg';
import { I18n, translate } from 'components/translate';
import { ContentPageService } from 'modules/content';
import SidebarEvents from 'modules/navigation/events';
import PropTypes from 'prop-types';

import { getPreviewTypes } from './utils/previewTypes';

import '@hotmart/cosmos/dist/collapse';
import '@hotmart/cosmos/dist/menu-item';

import './ListViewAs.scss';

const ListViewAs = ({ t }) => {
  const handlePreviewAs = (role) => {
    if (role) {
      SidebarEvents.sendPreviewAs(role);
      ContentPageService.contentPreview(null, role);
    }
  };

  const previewTypes = getPreviewTypes();

  return (
    <hot-menu-item>
      <div className="hot-application-menu__icon">
        <img src={EyeIcon} alt={t('general.view_as')} />
      </div>

      <span>{t('general.view_as')}</span>

      {previewTypes &&
        previewTypes?.map(({ label, role }) => (
          <hot-menu-item slot="collapsed" key={role}>
            <span
              className="submenu-item"
              data-test={role}
              onClick={() => handlePreviewAs(role)}
            >
              <I18n label={label} checkOnlineEvent />
            </span>
          </hot-menu-item>
        ))}
    </hot-menu-item>
  );
};

ListViewAs.propTypes = {
  t: PropTypes.func
};

export default translate('translate')(ListViewAs);
